import React, { useState } from 'react';
import { Button } from '@nextui-org/react';

function DeletePopupComponent(props) {
  const [isOpen, setIsOpen] = useState(true)

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      // Eğer overlay alanına tıklanırsa kapat
      setIsOpen(false)
    }
  }

  const handleNoButtonClick = () => {
    setIsOpen(false)
  }

  const delProject = async () => {
    // TODO: Implement delete project service
    handleClose();
  }
  return (
    <>
      {isOpen && (
        <div className="z-50 absolute inset-0 flex justify-center items-center" onClick={handleBackgroundClick}>
          <div className="bg-black opacity-50 fixed inset-0 cursor-pointer"></div>
          <div className="bg-white w-[300px] h-[170px] rounded-3xl relative z-50">
            <div className="flex justify-center items-center">
              <h1 className="p-2 font-semibold text-green-400">Projeden Ayrıl</h1>
            </div>
            <div className="w-full border-t border-gray-300"></div>
            <div className="p-4">
              <p className="text-sm text-center mb-4">Bu projeden ayrılmak istediğinize emin misiniz?</p>
              <div className="flex justify-center space-x-2">
                <Button className="bg-green-400 font-semibold text-md text-white" color="secondary" onClick={() => {}}>
                  Evet, Ayrıl
                </Button>
                <Button className="bg-gray-400 font-semibold text-md text-white" color="secondary" onClick={handleNoButtonClick}>
                  Hayır, Kalsın
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default DeletePopupComponent
